module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Thank you, Austin Macauley, especially Luke Davies and Alexander Holiday, for helping me through this new publishing experience, proof readers and copy editors for patience with my tenses tantrums and propensity to deliberately mangle words and invent new ones.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Also gratitude to Clif Barfield, Susan Gillis, Maggie Kitching, Fran Bing, Jack Kitterhing-Best and also Aylsham Quakers for interest, support and giggling.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee3483c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0